<template>
  <div
    v-if="show.cheat === false"
    class="browse"
    :id="'browse_' + type"
  >
    <div class="flex wrap between align-center p8 label">
      <div class="flex between flexy align-center md-font b4">
        <b class>
          <i :class="$store.state.icons[type]" class></i>
          {{ type.toUpperCase() }}
        </b>
        <span v-if="$route.name === 'tags'" class="xs-font">
          Tagged with
          <code class="indicate-text">
            <i class="fas fa-hashtag"></i>
            {{ $route.params.tag }}
          </code>
        </span>
      </div>
      <div class="fill flex wrap align-center">
        <div class="flex wrap align-center flexy fill between xs-font">
          <input
            :id="'browse_' + type + '_search'"
            v-model="$store.state.search[type]"
            class="input-with-icon sm-font xs-input"
            :class="'browse_' + type + '_search'"
            type="text"
            :placeholder="'Search ' + type"
          />
          <span
            class="flex around align-center"
            :class="'browse_' + type + '_views'"
          >
            <h5>Views</h5>
            <a
              :class="
                show.view[type] === 'grid' ? 'update-text' : ''
              "
              href
              type="button"
              class="p4 r4"
              @click.prevent="$set(show.view, type, 'grid')"
            >
              <i class="fa fa-table fa-xs r4"></i> Grid
            </a>
            /
            <a
              :class="
                show.view[type] === 'list' ? 'update-text' : ''
              "
              href
              type="button"
              class="p4"
              @click.prevent="$set(show.view, type, 'list')"
            >
              <i class="fas fa-th-list fa-xs r4"></i>List
            </a>
            /
            <a
              :class="show.view[type] === 'post' ? 'update-text' : ''"
              class="p4"
              @click.prevent="
                $set(show.view, type, 'post');
                
              "
            >
              <i class="fas fa-th-list fa-xs r4"></i>Post
            </a>
          </span>
          <a
            :class="show.sorts ? 'update-text' : ''"
            href
            @click.prevent="show.sorts = !show.sorts"
            type="button"
            class="p4"
          >
            <i class="fa fa-sort r4"></i>Sort
          </a>
          <a
            :class="show.filters ? 'update-text' : ''"
            href
            @click.prevent="show.filters = !show.filters"
            type="button"
            class="p4"
          >
            <i class="fa fa-sort r4"></i>Filters
          </a>
          <div
            class="flex wrap align-center p8 around fill"
            v-if="show.sorts"
            :class="'browse_' + type + '_sort'"
          >
            <a
              href
              @click.prevent="sort(prop)"
              type="button"
              class="r4 xs-font b4"
              :key="propKey"
              v-for="(prop, propKey) in filterProps[type]"
            >
              <span
                :class="
                  $store.state.sorts[type] &&
                  $store.state.sorts[type][0] === prop
                    ? 'update-text'
                    : ''
                "
                class="r4 sm-font"
              >
                {{ prop.indexOf(".") > -1 ? prop.split(".")[1] : prop }}
                <i
                  class="fa-xs"
                  :class="
                    $store.state.sorts[type] &&
                    $store.state.sorts[type][0] === prop
                      ? $store.state.sorts[type][1] === 1
                        ? 'fas fa-sort-down'
                        : 'fas fa-sort-up'
                      : ''
                  "
                ></i>
              </span>
            </a>
          </div>
        </div>
        <div class="flex wrap column p8 b8 border" v-if="show.filters">
          <div class="flex between align-center b8">
            <b class="r16">Filters</b>
            <button @click="clearFilters()" type="button" class="r8 xs-font">Clear All</button>
          </div>
          
          <!-- All Filters -->
          <div class="flex wrap column b8" v-if="activeFilters.all && activeFilters.all.length > 0">
            <b class="xs-font r8">Must Match ALL:</b>
            <div class="flex wrap">
              <span
                v-for="(condition, condKey) in activeFilters.all"
                :key="'all-' + condKey"
                class="xs-font r4 b4 p4 flex align-center"
              >
                {{ formatCondition(condition) }}
                <i class="fas fa-times r8 p4" @click="removeFilter('all', condKey)" style="cursor: pointer;"></i>
              </span>
            </div>
          </div>
          
          <!-- Except Filters -->
          <div class="flex wrap column b8" v-if="activeFilters.except && activeFilters.except.length > 0">
            <b class="xs-font r8">Must NOT Match:</b>
            <div class="flex wrap">
              <span
                v-for="(condition, condKey) in activeFilters.except"
                :key="'except-' + condKey"
                class="xs-font r4 b4 p4 flex align-center"
              >
                {{ formatCondition(condition) }}
                <i class="fas fa-times r8 p4" @click="removeFilter('except', condKey)" style="cursor: pointer;"></i>
              </span>
            </div>
          </div>
          
          <!-- Add Filter -->
          <div class="flex wrap column b8">
            <b class="xs-font r8">Add Filter:</b>
            <div class="flex wrap align-center">
              <select v-model="newFilter.type" class="xs-input r4">
                <option value="all">Must Match (ALL)</option>
                <option value="except">Must NOT Match (EXCEPT)</option>
              </select>
              <select v-model="newFilter.field" class="xs-input r4">
                <option value="">Select Field</option>
                <option
                  v-for="(prop, propKey) in filterProps[type]"
                  :key="propKey"
                  :value="prop"
                >{{ prop.indexOf(".") > -1 ? prop.split(".")[1] : prop }}</option>
              </select>
              <input
                v-model="newFilter.value"
                type="text"
                placeholder="Value"
                class="xs-input r4"
                @keyup.enter="addFilter()"
              />
              <select v-model="newFilter.operator" class="xs-input r4">
                <option value="includes">Includes</option>
                <option value="equals">Equals</option>
                <option value="!includes">Not Includes</option>
                <option value="!===">Not Equals</option>
                <option value="exists">Exists</option>
                <option value="!exists">Not Exists</option>
              </select>
              <button @click="addFilter()" type="button" class="r4 xs-font">Add</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <keep-alive> 
      <component
        :sort="$store.state.sorts[type] ? $store.state.sorts[type][1] : 1"
        :order="sortby"
        :limit="limit"
        :filter="mergedFilter"
        :view="passview.view || 'list'"
        v-if="show.view[type]"
        :id="'ilist_' + type.norm()"
        :class="'ilist_' + type.norm()"
        class="ilist flex wrap"
        :key="type + passview.view + filterKey"
        :is="'ilist'"
        :type="type"
        v-bind="passview"
      ></component>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "browse",
  computed: {
    passview(){
      return {view: this.show.view[this.type] || this.view || 'list'}
    },
    filterProps() {
      this.$set(this.filterProperties, this.type, []);
      if (this.$store.state.app.forms[this.type]) {
        this.$store.state.app.forms[this.type].forms.forEach((form) => {
          form.inputs.forEach((input) => {
             this.filterProperties[this.type].push(form.name + "." + input.label);
          });
        });
      }
      this.$set(this.filterProperties, this.type, [
        ...this.filterProperties[this.type],
        "basics.tags",
        "user",
        "created",
      ]);
      return this.filterProperties;
    },
    activeFilters() {
      // Merge prop filterConfig with UI filters
      const baseFilter = this.filterConfig || {};
      const uiFilter = this.filtr || {};
      
      return {
        all: [
          ...(baseFilter.all || []),
          ...(uiFilter.all || [])
        ],
        except: [
          ...(baseFilter.except || []),
          ...(uiFilter.except || [])
        ]
      };
    },
    mergedFilter() {
      const hasFilters = (this.activeFilters.all && this.activeFilters.all.length > 0) ||
                        (this.activeFilters.except && this.activeFilters.except.length > 0);
      return hasFilters ? this.activeFilters : null;
    },
    filterKey() {
      // Create a key based on filter state to force re-render when filters change
      return JSON.stringify(this.activeFilters);
    }
  },
  data() {
    return {
      filterProperties: {},
      filterThrough: [],
      // order: '',
      filtr: {},
      show: {
        cheat: false,
        filters: false,
        sorts: false,
        view: {}
      },
      sortby: this.order || '',
      loaded: false,
      newFilter: {
        type: 'all',
        field: '',
        value: '',
        operator: 'includes'
      }
    };
  },
  metaInfo() {
    return {
      title: this.type,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.$store.state.app.basics.mission || "XMBL App"
        },
      ],
    };
  },
  methods: {
    sort(prop) {
      if (prop === "clear") {
        return this.$delete(this.$store.state.sorts, this.type);
      }
      var direction =
        this.$store.state.sorts[this.type] &&
        this.$store.state.sorts[this.type][1] === 1
          ? -1
          : 1;
      this.$delete(this.$store.state.sorts, this.type);
      this.$set(this.$store.state.sorts, this.type, [prop, direction]);
      this.$set(this, 'sortby', false)
      this.$set(this, 'sortby', prop)
      return true
    },
    addFilter() {
      if (!this.newFilter.field || !this.newFilter.value) return;
      
      const condition = {
        field: this.newFilter.field,
        value: this.newFilter.value,
        operator: this.newFilter.operator
      };
      
      if (!this.filtr[this.newFilter.type]) {
        this.$set(this.filtr, this.newFilter.type, []);
      }
      this.filtr[this.newFilter.type].push(condition);
      
      // Reset form
      this.newFilter = {
        type: 'all',
        field: '',
        value: '',
        operator: 'includes'
      };
    },
    removeFilter(type, index) {
      if (this.filtr[type] && this.filtr[type][index]) {
        this.filtr[type].splice(index, 1);
        if (this.filtr[type].length === 0) {
          this.$delete(this.filtr, type);
        }
      }
    },
    clearFilters() {
      this.filtr = {};
    },
    formatCondition(condition) {
      if (typeof condition === 'string') {
        return condition;
      }
      if (typeof condition === 'object') {
        const field = condition.field || condition.path || '';
        const value = condition.value || '';
        const operator = condition.operator || 'equals';
        const fieldName = field.indexOf('.') > -1 ? field.split('.').pop() : field;
        return `${fieldName} ${operator} ${value}`;
      }
      return String(condition);
    },
  },
  props: { 
    type: { type: String }, 
    limit: { type: String }, 
    order: { type: String }, 
    view: { type: String },
    filterConfig: { 
      type: Object, 
      default: () => null,
      validator: (value) => {
        if (!value) return true;
        return (value.all === undefined || Array.isArray(value.all)) &&
               (value.except === undefined || Array.isArray(value.except));
      }
    }
  },
  mounted() {
    this.$set(this.show.view, this.type, this.view || 'list')
    if (!this.type) {
      this.type = this.$route.params.type;
    }
    if (!this.order) {
      this.loaded = true;
    }
    
    // Auto-add tag filter from route if present
    if (this.$route.name === 'tags' && this.$route.params.tag) {
      if (!this.filtr.all) {
        this.$set(this.filtr, 'all', []);
      }
      // Check if tag filter already exists
      const tagFilterExists = this.filtr.all.some(f => 
        (typeof f === 'object' && f.field === 'basics.tags' && f.value === this.$route.params.tag) ||
        (typeof f === 'string' && f.startsWith('basics.tags:') && f.includes(this.$route.params.tag))
      );
      if (!tagFilterExists) {
        this.filtr.all.push({
          field: 'basics.tags',
          value: this.$route.params.tag,
          operator: 'includes'
        });
      }
    }
  },
  created(){
      setTimeout(() => this.order && this.sort(this.sortby), 1000);
  },
  watch: {
    '$route.params.tag'(newTag, oldTag) {
      if (newTag && newTag !== oldTag && this.$route.name === 'tags') {
        // Update tag filter when route changes
        if (!this.filtr.all) {
          this.$set(this.filtr, 'all', []);
        }
        // Remove old tag filters
        this.filtr.all = this.filtr.all.filter(f => 
          !(typeof f === 'object' && f.field === 'basics.tags') &&
          !(typeof f === 'string' && f.startsWith('basics.tags:'))
        );
        // Add new tag filter
        this.filtr.all.push({
          field: 'basics.tags',
          value: newTag,
          operator: 'includes'
        });
      }
    },
    filterConfig: {
      handler(newVal) {
        if (newVal && (newVal.all || newVal.except)) {
          // Filter config changed externally, force update
          this.$forceUpdate();
        }
      },
      deep: true
    }
  }
};
</script>
<style>
.filter-sort {
  display: flex;
}
.sort-button {
  margin: 0;
  background: rgba(0, 0, 0, 0.6);
}
.filter-button {
  margin: 0 4px 0 0;
  background: rgba(0, 0, 0, 0.6);
}
.sort-button:hover,
.filter-button:hover {
  background: rgba(0, 0, 0, 1);
}
.events-title {
  font-size: 2em;
  font-weight: 900;
}
.desc {
  height: 100px;
  overflow: hidden;
}
.add-cart {
  font-size: 1.4em;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.page-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 4px;
}
.page-heading h1 {
  margin: 0;
}
.page-heading input {
  font-size: 1.2em;
}
.browse-nav-button {
  background: rgba(36, 218, 187, 0.8);
  flex: 0 0 auto;
}
.browse-nav-button:hover {
  background: rgb(37, 212, 183);
}
.active-input {
  flex: 0 1 auto;
}
.time-space {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.browse-page {
  text-align: left;
  justify-content: space-around;
}
.browse-list {
  display: flex;
  flex-wrap: wrap;
  flex-direction: reverse;
}
.browse-image {
  height: auto;
  max-width: 540px;
  object-fit: cover;
}

/* Text wrapping fixes for browse component */
.browse {
  overflow: hidden;
  word-wrap: break-word;
}

.browse .ilist {
  overflow: hidden;
  word-wrap: break-word;
}

.browse .ilist * {
  max-width: 100%;
  box-sizing: border-box;
}
</style>

